import React from "react";
import { styled } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";

const StyledAvatarOff = styled(Avatar)(({ shift, size, width }) => ({
  width: width ? width : 32,
  height: width ? width : 32,
  fontWeight: 600,
  opacity: 0.8,
  backgroundColor: "#fdf3f5",
  border: "2px solid #e46a76",
  "& .MuiTypography-root": {
    fontWeight: "bold",
    fontSize: size ? size : 16,
    lineHeight: 0,
    color: "#e46a76",
  },
}));

export default function AvatarOff({ shift, size, width }) {
  return (
    <StyledAvatarOff shift={shift} size={size} width={width}>
      <Typography variant="body2">{"OFF"}</Typography>
    </StyledAvatarOff>
  );
}
